import React from "react";
import {
  Col,
  Row,
  Form,
  Button,
  Container,
  Image,
} from "@themesberg/react-bootstrap";
import LoginBgImg from "../assets/img/login-bg.png";
import AutoGeniLogo from "../assets/img/auto-geni-logo-light.svg";
import CompanyImg from "../assets/img/wizzard/company-img.svg";
import WorkerImg from "../assets/img/wizzard/worker-img.svg";

export const StepNav = () => {
  const stepsLabels = [
    "Company Profile",
    "Add Workers",
    "Subscription",
    "Payment",
  ];

  return (
    <Row className="mb-6">
      <Col>
        <ul className="list-inline d-flex justify-content-between">
          {stepsLabels.map((label, index) => (
            <li key={index}>
              <span className="step-number border me-1">{index + 1}</span>
              {label}
            </li>
          ))}
        </ul>
      </Col>
    </Row>
  );
};

export const StepCompany = () => {
  return (
    <Row>
      <Col>
        <div className="text-center mb-5">
          <img src={CompanyImg} alt="Company Profile" />
          <h3 className="mt-2">Company Profile</h3>
        </div>
        <Form>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Company Name</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Store ID {`(Optional)`} </Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Phone #</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Number of Employees</Form.Label>
                <Form.Select>
                  <option defaultChecked>0-50</option>
                  <option value="1">50-100</option>
                  <option value="2">100+</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <Form.Control type="email" />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>City</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Select state</Form.Label>
                <Form.Select id="state" defaultValue="0">
                  <option value="0">State</option>
                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="DC">District Of Columbia</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Zip Code</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export const StepWorkers = () => {
  return (
    <Row>
      <Col>
        <div className="text-center mb-5">
          <img src={WorkerImg} alt="Company Profile" />
          <h3 className="mt-2">Add Workers</h3>
          <p>Workers added will be notified with a welcome email.</p>
        </div>
        <Form>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Company Name</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Store ID {`(Optional)`} </Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Phone #</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Number of Employees</Form.Label>
                <Form.Select>
                  <option defaultChecked>0-50</option>
                  <option value="1">50-100</option>
                  <option value="2">100+</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export const StepSubscriptions = () => {
  return (
    <div>
      <p>
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eum, veniam?
      </p>
    </div>
  );
};

export const StepControls = () => {
  return (
    <Row>
      <Col className="d-flex justify-content-between mt-4">
        <Button variant="outline-primary">Back</Button>
        <Button bsPrefix="text" variant="primary">
          Skip For Now
        </Button>
        <Button variant="primary">Next</Button>
      </Col>
    </Row>
  );
};

const RegisterWizard = () => {

  return (
    <Container fluid className="min-vh-100 bg-primary p-0">
      <Row>
        <Col
          md={4}
          className="text-white vh-100 p-5 "
          style={{
            backgroundImage: `url(${LoginBgImg})`,
            backgroundSize: "cover",
          }}
        >
          <Image src={AutoGeniLogo} height={71} alt="Auto Geni Logo" />
          <h1 className="display-2 mt-5 w-75">Welcome, Alian! </h1>
          <p className="fw-light my-4 h5 w-75">
            There are a few steps you need to complete in order to get you
            started.
          </p>
        </Col>

        <Col md={8} className="bg-white p-4 ">
          <Row className="w-75 mx-auto">
            <Col>
              <StepNav />
              <StepWorkers />
              <StepControls />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default RegisterWizard;
